import React from 'react';
import I18n from 'i18n-js';

import { core_apimessages_Money } from '../schemas/rql';
import { KlarnaLearnMoreButton } from './KlarnaLearnMoreButton';
import { KlarnaCallout } from './KlarnaCallout';
import { parseAmountCents } from '@reverbdotcom/commons/src/money';

type Money = Pick<core_apimessages_Money, 'amountCents' | 'currency'>;

interface Props {
  amount: Money;
  textOnly: boolean;
}

export function KlarnaPayLaterCallout({ amount, textOnly }: Props) {
  return (
    <KlarnaCallout
      paymentPlan={translate('paymentPlan')}
      textOnly={textOnly}
      learnMore={
        <KlarnaLearnMoreButton
          description={
            {
              title: translate('learnMoreButton.title', { amount: displayAmount(amount) }),
            }
          }
          additionalSteps={
            [
              additionalStep('shopTodayPayLater'),
              additionalStep('makePayment'),
            ]
          }
        />
      }
    />
  );
}

function additionalStep(key: string) {
  return {
    key,
    value: translate(`learnMoreButton.additionalSteps.${key}`),
  };
}

function displayAmount(amount: Money) {
  return parseAmountCents(amount.amountCents, amount.currency).display;
}

function translate(key: string, args = {}) {
  return I18n.t(`discovery.klarnaCallout.payLater.${key}`, args);
}
